<template>
  <InicioCoordenador modo-diretor :periodo="periodo" @carregando="$emit('carregando', $event)" />
</template>

<script>
import InicioCoordenador from "@/components/InicioCoordenador.vue";

export default {
  name: "InicioDiretor",
  props: {
    periodo: {
      type: Object,
      required: true,
    },
  },
  components: {
    InicioCoordenador,
  },
};
</script>
